import React, { useEffect, useState } from 'react';
import { ButtonWithIconShareLink } from 'chameleon/ui-stack/utilities/share-link';
import useShareLinkTooltip from './share/useTooltip';
import useShareLinkText from './share/useText';
import useShareLinkNotification from './share/useNotification';

const useModalTitle = (
  subjectId,
  items,
  unitTitle,
  unitId,
  subunitTitle = null,
  subunitLabel,
  assignAll,
) => {
  const [title, setTitle] = useState('');
  const [elements, setElements] = useState({
    title: <div />,
    subTitle: null,
    topBar: null,
  });
  const shareLinkTooltip = useShareLinkTooltip(items);
  const shareableText = useShareLinkText(subjectId, unitId, items);
  const shareLinkNotification = useShareLinkNotification(items);
  const assignBulkVideos = assignAll && items.length > 1;

  const getTitleByUnitOrSubunit = () => {
    let result = `Assign ${unitTitle}`;
    if (subunitTitle) {
      if (subunitLabel === 'Topics') {
        result = `Assign ${subunitTitle}`;
      } else {
        result += `: ${subunitTitle}`;
      }
    }

    result += ' Daily Videos';

    return result;
  };

  useEffect(() => {
    setTitle(
      assignBulkVideos
        ? getTitleByUnitOrSubunit()
        : `Assign ${items[0].displayName}`,
    );
  }, [items]);

  useEffect(() => {
    setElements({
      title,
      subTitle:
        (assignBulkVideos && <span className="mr-4">({items.length})</span>) ||
        null,
      topBar: (
        <ButtonWithIconShareLink
          text={shareableText}
          notificationText={shareLinkNotification}
          tooltip={shareLinkTooltip}
        >
          Copy Link{items.length > 1 ? 's' : ''}
        </ButtonWithIconShareLink>
      ),
    });
  }, [title, shareLinkTooltip, shareableText, shareLinkNotification]);

  return elements;
};

export default useModalTitle;
